import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User } from '../../api/supabaseEntities.js';
import { createPageUrl } from '../../utils/index.ts';

const AuthGuard = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Páginas que não precisam de autenticação
  const publicPages = ['adminlogin', 'clientlogin', 'clientrecovery'];
  const currentPath = location.pathname.toLowerCase().replace('/', '');
  const isPublicPage = publicPages.includes(currentPath) || location.pathname === '/';

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  // Escutar evento de atualização de perfil
  useEffect(() => {
    const handleProfileUpdate = () => {
      console.log('👤 AuthGuard - Perfil atualizado, recarregando dados do usuário...');
      checkAuth();
    };

    // Adicionar listener para evento customizado
    window.addEventListener('userProfileUpdated', handleProfileUpdate);
    
    // Cleanup
    return () => {
      window.removeEventListener('userProfileUpdated', handleProfileUpdate);
    };
  }, []);

  const checkAuth = async () => {
    console.log('🔐 AuthGuard - Verificando autenticação para:', location.pathname);
    
    // Se for página pública, não verificar autenticação
    if (isPublicPage) {
      console.log('📖 Página pública detectada, liberando acesso');
      setIsLoading(false);
      return;
    }

    try {
      console.log('🔍 Verificando usuário autenticado...');
      const userData = await User.me();
      
      if (userData) {
        console.log('✅ Usuário autenticado:', userData.email);
        console.log('🖼️ Avatar URL:', userData.avatar_url);
        setUser(userData);
      } else {
        console.log('❌ Usuário não encontrado, redirecionando para login');
        navigate(createPageUrl('AdminLogin'));
        return;
      }
    } catch (error) {
      console.log('❌ Erro de autenticação, redirecionando para login:', error.message);
      navigate(createPageUrl('AdminLogin'));
      return;
    }

    setIsLoading(false);
  };

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-slate-400">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  // Para páginas públicas, renderizar diretamente
  if (isPublicPage) {
    return children;
  }

  // Para páginas protegidas, só renderizar se tiver usuário
  if (user) {
    return React.cloneElement(children, { user });
  }

  // Se chegou aqui, algo deu errado
  return null;
};

export default AuthGuard; 